import twitterIcon from "../images/icons/twitter.svg";
import githubIcon from "../images/icons/github.svg";

const MySocials = [
  {
    name: "Github",
    icon: githubIcon,
    link: "https://github.com/enodd",
  },
  {
    name: "Twitter",
    icon: twitterIcon,
    link: "https://twitter.com/denoddnowak",
  },
];

export default MySocials;
